import React from 'react';
import { useSelector } from 'react-redux';
import { openFranchiseFinmodelForm } from './franchiseConstants';
import { fromStore } from '../../selectors';

export function FinalSection() {
  const cities = useSelector(fromStore.citiesListSelector);
  const points = (cities || []).reduce((sum, city) => sum + (city.points?.length || 0), 0);
  const renderCitiesText = () => {
    const lastTwo = cities.length % 100;

    if (lastTwo > 10 && lastTwo < 20) {
      return 'городов';
    }

    const lastDigit = cities.length % 10;

    if (lastDigit === 1) {
      return 'город';
    }

    if (lastDigit > 1 && lastDigit < 5) {
      return 'города';
    }

    return 'городов';
  };
  const renderPointsText = () => {
    const lastTwo = cities.length % 100;

    if (lastTwo > 10 && lastTwo < 20) {
      return 'точек';
    }

    const lastDigit = points % 10;

    if (lastDigit === 1) {
      return 'точка';
    }

    if (lastDigit > 1 && lastDigit < 5) {
      return 'точки';
    }

    return 'точек';
  };
  const renderVerbForm = () => {
    const lastDigit = points % 10;

    if (lastDigit === 1) {
      return 'работает';
    }

    return 'работают';
  };

  return (
    <section id="s-final" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-final" data-reveal>
          <div className="franchise-final__top">
            <div className="franchise-final__top__banner">Получите финансовую модель под ваш город</div>
          </div>
          <div className="franchise-final__content">
            <div className="franchise-final__content__l-side">
              <img src="/assets/media/franchise/final-section/map.png" alt="Map" />
            </div>
            <div className="franchise-final__content__r-side">
              <div className="franchise-final__content__r-side__text"> Рассчитаем инвестиции, окупаемость <br /> и потенциальную прибыль именно <br /> для вашего населённого пункта. </div>
              <button type="button" className="franchise-final__content__r-side__button" onClick={openFranchiseFinmodelForm()}>Получить финансовую модель</button>
              <div className="franchise-final__content__r-side__text-contact">
                <div>или</div>
                <div>Свяжитесь с нами удобным способом</div>
              </div>
              <div className="franchise-final__content__r-side__contacts">
                <button type="button" className="franchise-final__content__r-side__contacts__button" onClick={() => { window.open('https://t.me/sushibox_franch', '_blank'); }}>
                  <img src="/assets/media/franchise/final-section/telegram.svg" alt="Telegram" />
                  Telegram
                </button>
                <button type="button" className="franchise-final__content__r-side__contacts__button" onClick={() => { window.open('https://wa.me/79614050322', '_blank'); }}>
                  <img src="/assets/media/franchise/final-section/whatsapp.svg" alt="WhatsApp" />
                  WhatsApp
                </button>
              </div>
            </div>
          </div>
          <div className="franchise-final__footer">
            <div>
              <img src="/assets/media/franchise/final-section/shop-icon.svg" alt="Shop" />
              <div>{points}</div>
              <div>{renderPointsText()} <br /> уже {renderVerbForm()}</div>
            </div>
            <div>
              <img src="/assets/media/franchise/final-section/location.svg" alt="Location" />
              <div>{cities.length}</div>
              <div>{renderCitiesText()} <br /> присутствия</div>
            </div>
            <div>
              <img src="/assets/media/franchise/final-section/calendar.svg" alt="Calendar" />
              <div>10</div>
              <div>лет <br /> опыта</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
